import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppointmentType } from '../../types';

@Component({
  selector: 'hh-appointment-list-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './appointment-list-item.component.html',
  styleUrls: ['./appointment-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppointmentListItemComponent {
  @Input()
  public type: AppointmentType = 'generic';

  @Input()
  public time = '';

  @Input()
  public label = '';

  @Input()
  public description?: string;

  protected get typeClass(): string {
    switch (this.type) {
      default:
      case 'generic':
        return 'type--generic';
      case 'medication':
        return 'type--medication';
      case 'appointment':
        return 'type--appointment';
      case 'reminder':
        return 'type--reminder';
    }
  }
}
